import { render, staticRenderFns } from "./EditTipeBarang.vue?vue&type=template&id=4fa6f980&"
import script from "./EditTipeBarang.vue?vue&type=script&lang=js&"
export * from "./EditTipeBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports